import { getAnalytics } from "@tm/insurance/analytics";
import { navigationActions } from "@tm/insurance/navigation";
import { theme } from "@tm/utility/global";
import FlexComp from "../FlexComp/FlexComp";
import FormattedText from "../FormattedText/FormattedText";
import { ImageComponent } from "../ImageComponent/ImageComponent";
import AnchorTag from "../TextStyles/AnchorTag";
import { ItineraryContainer, Separator } from "./ItineraryInfoComp.styles";

type TravelDates = {
  startDate: number;
  endDate: number;
};

type TravelDetails = {
  countries?: string;
  travelDates?: TravelDates;
  travellerCount?: number;
  travelMode?: string;
};

type ItineraryInfoCompProps = {
  travelDetails: TravelDetails;
};

const formatDate = (timestamp: number): string => {
  const date = new Date(timestamp * 1000);
  const day = date.getDate();
  const month = date.toLocaleDateString("en-US", { month: "short" });
  const year = date.getFullYear().toString().slice(-2);
  return `${day} ${month}' ${year}`;
};

const ItineraryInfoComp = ({ travelDetails }: ItineraryInfoCompProps) => {
  const { countries, travelDates, travellerCount } = travelDetails;
  const analytics = getAnalytics();

  const startDateFormatted = formatDate(
    travelDates?.startDate || new Date().getTime()
  );
  const endDateFormatted = formatDate(
    travelDates?.endDate || new Date().getTime()
  );
  const travellerText = travellerCount === 1 ? "Traveller" : "Travellers";

  const handleEditClick = () => {
    if (document.referrer) {
      navigationActions.goBack();
    }
    analytics?.trackListingEvents({
      actionType: "edit_clicked",
    });
    const queryParams = new URLSearchParams(window.location.search);
    const partnerBookingId = queryParams.get("partnerBookingId");
    const params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers"),
      segment: queryParams.get("segment"),
      type: queryParams.get("type") || "",
      itineraryId: queryParams.get("itineraryId") || "",
      ...(partnerBookingId && {
        partnerBookingId,
      }),
    };
    navigationActions.navigateToLanding(params, false);
  };

  return (
    <ItineraryContainer>
      <FlexComp justifyContent="space-between">
        <FlexComp gap="16px" alignItems="center">
          <FormattedText
            value={countries}
            baseStyle={{
              fontWeight: 700,
              fontSize: "18px",
              color: theme.blackText,
            }}
          />
          <Separator />
          <FormattedText
            value={`${startDateFormatted} -To- ${endDateFormatted}`}
            baseStyle={{
              fontWeight: 400,
              fontSize: "16px",
              color: theme.greyText,
            }}
          />
          <Separator />
          <FormattedText
            value={`${travellerCount} ${travellerText}`}
            baseStyle={{
              fontWeight: 400,
              fontSize: "16px",
              color: theme.greyText,
            }}
          />
        </FlexComp>
        <AnchorTag handleClick={handleEditClick}>
          <ImageComponent
            width="25px"
            height="25px"
            src="https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg"
          />
        </AnchorTag>
      </FlexComp>
    </ItineraryContainer>
  );
};

export default ItineraryInfoComp;
